import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { Endereco, ParametrosBuscaEndereco, RespostaViaCEP } from '../models/endereco.model';

/**
 * Token de injeção para o repositório CEP
 */
export const CEP_REPOSITORY = new InjectionToken<CEPRepository>('CEPRepository');

/**
 * Interface do repositório para consulta de CEP
 * Define os contratos para acesso aos dados de endereço
 */
export interface CEPRepository {
  /**
   * Consulta um endereço pelo CEP
   * @param cep CEP no formato de 8 dígitos (ex: "01001000")
   * @returns Observable com os dados do endereço ou erro
   */
  consultarPorCEP(cep: string): Observable<RespostaViaCEP>;

  /**
   * Busca CEPs por endereço (UF, cidade e logradouro)
   * @param parametros Parâmetros da busca (UF, cidade, logradouro)
   * @returns Observable com array de endereços encontrados
   */
  buscarPorEndereco(parametros: ParametrosBuscaEndereco): Observable<Endereco[]>;
}
